import styled from 'styled-components';

export const Image = styled.img`
  width: 36px;
  height: 36px;

  cursor: pointer;
  object-fit: cover;
  border-radius: 50%;
`;
